import type { IIntegration } from '../../api';
import type { OpenEntityModalDataRelatedResource } from '../EntityModal/store';

const getDiscussionTeamIds = (
	entity: OpenEntityModalDataRelatedResource,
	integrations: IIntegration[]
): string[] => {
	// Check if the re\source has explicit teams defined
	if (entity.teams && entity.teams.length > 0) {
		// If so, we need to add them to the question
		return [entity.teams[0]];
	}

	// If the integration has teams, we need to add them to the question
	const integration = integrations?.find((i) => i.id === entity.integration);

	// If the integration has teams, we need to add them to the question
	if (integration?.teams) {
		return [integration.teams[0]];
	}

	// Return a de-duplicated list of teams since we may have added teams
	// from both the resource and the integration
	return [];
};

export { getDiscussionTeamIds as getDiscussionTeamIds };
